import styled from 'styled-components';
import {
  size,
  typography,
  mediaQueries,
  Col as RawCol,
  Row as RawRow,
} from '@everlywell/leaves';

export const Row = styled(RawRow)`
  ${mediaQueries.forTabletVerticalUp} {
    margin-top: ${size.xl2}px;
    margin-bottom: ${size.lg}px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.xl2}px;
  }
`;

export const TabMenuWrapper = styled(RawCol)`
  margin-bottom: ${size.xl4}px;
`;

export const DisplayTitle = styled.h2`
  ${typography.displayText}
  margin-bottom: ${size.lg}px;
  margin-top: ${size.lg}px;
  width: 100%;
  font-size: 22.8px;
  ${mediaQueries.forTabletVerticalUp} {
    font-size: ${size.xl1}px;
    margin-bottom: 0;
    margin-top: 0;
    text-align: left;
  }
`;

export const MobileFilter = styled(RawCol)`
  padding-bottom: ${size.md}px;
  ${mediaQueries.forTabletVerticalUp} {
    padding-bottom: 0;
  }
`;

export const SideDrawerItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ${mediaQueries.forTabletVerticalUp} {
    justify-content: flex-end;
    align-items: center;
  }
`;

export const NumberOfResults = styled.p`
  ${typography.bodyText}
  margin-right: ${size.md}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-right: 0;
  }
`;

export const SideDrawerTrigger = styled.div`
  display: flex;
  align-items: center;
`;
